module.exports = __webpack_public_path__ + "img/2025-15.280d1f27.jpg";